import has from 'lodash/has';
import * as types from '../../constants/actionTypes';
import { authFetch } from '../../api';
import { normalize } from 'normalizr';
import { setAdminNotification } from '../adminNotifications';
import { addEntities } from '../../actions/entities';

const request = () => ({
	type: types.ADMIN_NOTIFICATION_FETCH_REQUEST,
});

const success = notification => ({
	type: types.ADMIN_NOTIFICATION_FETCH_SUCCESS,
	payload: {
		notification,
	},
});

const failure = (message = 'Something went wrong.') => ({
	type: types.ADMIN_NOTIFICATION_FETCH_FAILURE,
	payload: {
		message,
	},
});

const getById = (entities, id) =>
	has(entities.adminNotifications[id], 'id')
		? entities.adminNotifications[id].id
		: false;

export default function get(id) {
	return (dispatch, getState, { schema }) => {
		const state = getState();
		const { token } = state.auth;

		if (getById(state.entities, id)) return dispatch(setAdminNotification(id));

		dispatch(request());

		authFetch(`admin-notifications/${id}`, {}, token, dispatch)
			.then(res => res.json())
			.then(res => {
				if (!has(res, 'admin_notification'))
					return has(res, 'error')
						? dispatch(failure(res.error))
						: dispatch(failure('Something went wrong.'));

				const data = normalize(
					[res.admin_notification],
					[schema.adminNotification]
				);

				dispatch(addEntities(data.entities));

				return dispatch(success(data.result[0]));
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/getAdminNotification.js